import React, { useState } from 'react'
import { parseISO, format } from 'date-fns'

import { Popover, ToolbarItem } from 'devextreme-react/popover'
import { Chat, Button } from 'devextreme-react'

import { useTheme } from '@mui/material/styles'
import { Typography } from '@mui/material'

import '../../theme/fontawesome.css'
import '../../theme/duotone.css'

import './ChatStyle.css'

const ChatDialog = (props) => {
    const theme = useTheme()

    const handleMsgHidden = (e) => {
        props.onHidden(props.id)
    }
    if (props.data?.id === -1) {
        document.documentElement.style.setProperty('--dx-chat-messagebox-display', 'none')
    } else {
        document.documentElement.style.setProperty('--dx-chat-messagebox-display', 'flex')
    }
    const messageEntered = (e) => {
        props.onSend(e.message, props.data.id)
    }
    const messageClear = (e) => {
        props.onClear(props.id, props.data?.id)
    }

    return (
        <Popover
            position={{ my: 'right top', at: 'right bottom', of: '#signalrmnu', collision: 'fit' }}
            hideOnOutsideClick={true}
            hideOnParentScroll={false}
            showCloseButton={true}
            onHidden={handleMsgHidden}
            visible={true}
        >
            <Chat
                showDayHeaders={false}
                user={props.usr}
                items={props.data.msg}
                onMessageEntered={messageEntered}
            />
            {props.data?.msg.length > 0 &&
                <ToolbarItem
                    toolbar='bottom'
                    location='after'
                >
                    <Button
                        stylingMode='contained'
                        type='normal'
                        text='Clear Messages'
                        onClick={messageClear}
                    />
                </ToolbarItem>
            }
        </Popover>
    )
}

export default ChatDialog
